import { Box } from "@mui/material";
// import Image from "next/image";
import React from "react";
// type SingleTabLabelProps = {
//   title: string;
//   count?: number|string;
//   icon?: string;
// };
export default function SingleTabLabel(props) {
  const { title, count, icon } = props;
  return (
    <Box className="tabBox">
      {icon ? (
        <Box className="tabIcon">
          <img src={icon} width={22} height={22} alt="" />
        </Box>
      ) : null}
      <p>
        {title} <br /> {count}
      </p>
    </Box>
  );
}
